import creditoService from '@/servicios/credito'
import { ERROR_OBTENER_OFERTA_DIGITAL } from '@/utilidades/errores'

export const ObtieneOfertaDigitalMixin = {
  data: () => ({
    consumiendoObtieneOfertaDigital: false,
  }),
  methods: {
    // Metodos publicos
    obtieneOfertaDigital(folioDigital = null) {
      this.$_ObtieneOfertaDigitalMixin_IniciaObtieneOfertaDigital()
      creditoService
        .obtenerOferta(folioDigital)
        .then((result) => {
          this.$_ObtieneOfertaDigitalMixin_TerminaObtieneOfertaDigital()
          if (result.status != 200) {
            this.errorObtieneOfertaDigital(ERROR_OBTENER_OFERTA_DIGITAL)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorObtieneOfertaDigital(data.Mensaje)
            return
          }
          this.postObtieneOfertaDigital(data.Modelo)
        })
        .catch((err) => {
          this.$_ObtieneOfertaDigitalMixin_TerminaObtieneOfertaDigital()
          console.error(err)
          this.errorObtieneOfertaDigital(ERROR_OBTENER_OFERTA_DIGITAL)
        })
    },
    postObtieneOfertaDigital() {},
    errorObtieneOfertaDigital(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ObtieneOfertaDigitalMixin_IniciaObtieneOfertaDigital() {
      this.consumiendoObtieneOfertaDigital = true
    },
    $_ObtieneOfertaDigitalMixin_TerminaObtieneOfertaDigital() {
      this.consumiendoObtieneOfertaDigital = false
    },
  },
}
